import React, { useState, useEffect, useContext } from "react";
import { C4FStatusContext, ReferenceDataContext } from "../main/App";
import { Row, Col, Container, Button, ButtonGroup, Table } from 'react-bootstrap';

import '../css/Profile.css';
import { getRaceEditionPrizeList, getRaceEditionRules } from "../common/Helpers";
import C4FSimpleTable from "../common/C4FSimpleTable";
import C4FPrizeMoney from "./C4FPrizeMoney";


function RaceEvents(props) {
    const { handleBackendRequest } = useContext(C4FStatusContext);
    const { raceRulesets, raceEventRules, commonRaceRules } = useContext(ReferenceDataContext);

    const [refresh, doRefresh] = useState(0);
    const [tab, setTab] = useState('actual');
    const [rules, setRules] = useState(null);
    const [raceEvents, setRaceEvents] = useState(null);
    const [raceEventsByRider, setRaceEventsByRider] = useState(null);
    const [raceEventsByTeam, setRaceEventsByTeam] = useState(null);
    const [raceEdition, setRaceEdition] = useState(null);

    useEffect(() => {
        if (raceEvents === null)
            loadRaceEvents();
    }, [props.raceEdition]);

    useEffect(() => {
        doRefresh(prev => prev + 1);
    }, [raceEvents]);

    // load race events
    function loadRaceEvents() {
        handleBackendRequest('GET', '/raceEdition/' + props.raceEdition.id + '/raceEvents', null,
            {
                teamName: 'teamName' in props ? props.teamName : '',
                stageNumber: 'currentStageForRaceEvents' in props.raceEdition ? props.raceEdition.currentStageForRaceEvents : null
            },
            function (raceEditionWithEvents) {
                setRaceEdition(raceEditionWithEvents);
                let rules = getRaceEditionRules(commonRaceRules, raceRulesets, raceEventRules, raceEditionWithEvents);
                setRules(rules);

                let raceEvents = getRaceEditionPrizeList(props.raceEdition, raceEditionWithEvents.raceEvents, rules);
                setRaceEvents(raceEvents);

                setRaceEventsByRider(aggregateByRider(raceEvents));
                setRaceEventsByTeam(aggregateByTeam(props.raceEdition, raceEvents, rules));
            }
        );
    }

    function aggregateByRider(raceEvents) {
        let riders = new Set();
        raceEvents.forEach(re => riders.add(re.riderName));

        let output = Array.from(riders).map(riderName => ({
            riderName: riderName,
            teamName: raceEvents.find(re => re.riderName === riderName).teamName,
            prizeMoney: raceEvents.filter(re => re.riderName === riderName)
                .reduce(function (value, o) { return value + o.prizeMoneyAdapted; }, 0),
            c4fPoints: raceEvents.filter(re => re.riderName === riderName)
                .reduce(function (value, o) { return value + o.c4fPointsAdapted; }, 0),
        }));

        return output;
    }

    function aggregateByTeam(raceEdition, raceEvents, rules) {
        let teams = new Set();
        let stages = new Set();
        if (raceEdition.teams.length > 0)
            raceEdition.teams.forEach(t => teams.add(t.team.teamName));
        else
            raceEvents.forEach(re => teams.add(re.teamName));

        raceEvents.forEach(re => {
            if (re.stageNumber > 0) stages.add(re.stageNumber);
        });
        let completedStages = Array.from(stages).length;
        let coveredSalary = 15000 + raceEdition.race.ridersPerTeam * 40000;

        let output = Array.from(teams).map(teamName => ({
            teamName: teamName,
            prizeMoney: Math.round(raceEvents.filter(re => re.teamName === teamName)
                .reduce(function (value, o) { return value + o.prizeMoneyAdapted; }, 0)),
            c4fPoints: Math.round(raceEvents.filter(re => re.teamName === teamName)
                .reduce(function (value, o) { return value + o.c4fPointsAdapted; }, 0)),
            salaryPerStage: raceEdition.teams.length > 0 ? - (Math.round(Math.max(0, raceEdition.teams.find(t => t.team.teamName === teamName).salary - coveredSalary) * rules.numberOfTeamsFactor)) : 0,
            totalSalary: raceEdition.teams.length > 0 ? - (Math.round(completedStages * Math.max(0, raceEdition.teams.find(t => t.team.teamName === teamName).salary - coveredSalary) * rules.numberOfTeamsFactor)) : 0
        }));


        if (output.length === 1 && raceEdition.financialTransaction) {
            output = output.map(o => ({
                ...o,
                salaryPerStage: raceEdition.financialTransaction.amount - o.prizeMoney,
                totalSalary: raceEdition.financialTransaction.amount - o.prizeMoney
            }))
        }

        output = output.map(o => ({
            ...o,
            profit: o.prizeMoney + o.totalSalary
        }));
        return output;
    }

    return <Container fluid className="container-fluid">
        <Row className="mt-1 d-flex justify-content-center">
            <ButtonGroup>
                <Button className="py-0 px-2" variant={tab === 'actual' ? 'secondary' : 'outline-secondary'}
                    onClick={() => setTab('actual')}>Actual Prizes and Points</Button>
                <Button className="py-0 px-2" variant={tab === 'rules' ? 'secondary' : 'outline-secondary'}
                    onClick={() => setTab('rules')}>Rules for this Race</Button>
            </ButtonGroup>
        </Row>
        {tab === 'actual' ?
            <>
                <Row className="mt-1 d-flex justify-content-center">
                    {rules ?
                        <Col className="col-8">
                            <Table className="table table-light table-striped mt-0 " size="sm">
                                <thead>
                                    {raceEdition.race.numberOfStages > 1 ?
                                        <>
                                            <th>Tour Points Factor</th>
                                            <th>Stage Points Factor</th>
                                            <th>Tour Prize Factor</th>
                                            <th>Stage Prize Factor</th>
                                        </>
                                        :
                                        <>
                                            <th>Points Factor</th>
                                            <th>Prize Factor</th>
                                        </>
                                    }
                                    <th>Teams Factor</th>
                                    <th>Group Factor</th>
                                </thead>
                                <tbody>
                                    <tr>
                                        {raceEdition.race.numberOfStages > 1 ?
                                            <td>{(Math.round(rules.c4fPointsCategoryFactorStageRace * 100) / 100).toFixed(2)}</td>
                                            : null}
                                        <td>{(Math.round(rules.c4fPointsCategoryFactorStage * 100) / 100).toFixed(2)}</td>
                                        {raceEdition.race.numberOfStages > 1 ?
                                            <td>{(Math.round(rules.prizeMoneyCategoryFactorStageRace * 100) / 100).toFixed(2)}</td>
                                            : null}
                                        <td>{(Math.round(rules.prizeMoneyCategoryFactorStage * 100) / 100).toFixed(2)}</td>
                                        <td>{(Math.round(rules.numberOfTeamsFactor * 100) / 100).toFixed(2)}</td>
                                        <td>{(Math.round(rules.groupNumberFactor * 100) / 100).toFixed(2)}</td>
                                    </tr>
                                </tbody>

                            </Table>
                        </Col>
                        : null}
                </Row>
                <Row className=" d-flex justify-content-center">
                    <Col className="my-2" style={{ maxHeight: 400, minWidth: 400, maxWidth: "80vw", overflow: "auto" }}>
                        {raceEvents ?
                            <C4FSimpleTable key={'raceEvents' + refresh}
                                data={raceEvents}
                                rowMetadata={[
                                    { columnName: 'stageNumber', columnDescription: 'Stage' },
                                    { columnName: 'sector', columnDescription: 'km' },
                                    { columnName: 'raceEventName', columnDescription: 'Event' },
                                    { columnName: 'position', columnDescription: 'Pos' },
                                    { columnName: 'riderName', columnDescription: 'Rider' },
                                    { columnName: 'teamName', columnDescription: 'Team' },
                                    { columnName: 'c4fPointsTotal', columnDescription: 'C4F Points Base' },
                                    { columnName: 'c4fPointsAdapted', columnDescription: 'C4F Points Actual' },
                                    { columnName: 'prizeMoneyTotal', columnDescription: 'Prize Money Base', columnType: 'currency' },
                                    { columnName: 'prizeMoneyAdapted', columnDescription: 'Prize Money Actual', columnType: 'currency' }
                                ]}
                            />
                            : null}
                    </Col>
                </Row>
                <Row className=" d-flex justify-content-center">
                    <Col className="col-8 my-2" style={{ maxHeight: 400, minWidth: 400, maxWidth: "80vw", overflow: "auto" }}>
                        <h6>Aggregated by Team (rounded)</h6>
                        {raceEventsByTeam ?
                            <C4FSimpleTable key={'raceEventsByTeam' + refresh}
                                data={raceEventsByTeam}
                                hideFilterButtons={true}
                                rowMetadata={[
                                    { columnName: 'teamName', columnDescription: 'Team' },
                                    { columnName: 'c4fPoints', columnDescription: 'C4F Points' },
                                    { columnName: 'prizeMoney', columnDescription: 'Prize Money', columnType: 'highlightedCurrency' },
                                    { columnName: 'totalSalary', columnDescription: 'Salary', columnType: 'highlightedCurrency' }]
                                    .concat(raceEdition.race.numberOfStages > 1 ?
                                        [{ columnName: 'salaryPerStage', columnDescription: 'Avg Salary', columnType: 'highlightedCurrency' }] : [])
                                    .concat([{ columnName: 'profit', columnDescription: 'Profit', columnType: 'highlightedCurrency' }])
                                }
                            />
                            : null}
                    </Col>
                </Row>
                <Row className=" d-flex justify-content-center">
                    <Col className="col-8 my-2" style={{ maxHeight: 400, minWidth: 400, maxWidth: "80vw", overflow: "auto" }}>
                        <h6>Aggregated by Rider</h6>
                        {raceEventsByRider ?
                            <C4FSimpleTable key={'raceEventsByRider' + refresh}
                                data={raceEventsByRider}
                                hideFilterButtons={true}
                                rowMetadata={[
                                    { columnName: 'riderName', columnDescription: 'Rider' },
                                    { columnName: 'teamName', columnDescription: 'Team' },
                                    { columnName: 'c4fPoints', columnDescription: 'C4F Points' },
                                    { columnName: 'prizeMoney', columnDescription: 'Prize Money', columnType: 'currency' }
                                ]}
                            />
                            : null}
                    </Col>
                </Row>
            </>
            : null}
        {tab === 'rules' ?
            <C4FPrizeMoney raceEdition={raceEdition} />
            : null}
    </Container>

}

export default RaceEvents;
